import { VueQueryPlugin } from '@tanstack/vue-query';
import DisableDevtool from 'disable-devtool';
import { createApp } from 'vue';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import App from './App.vue';
import directive from './directive/index.js';
import router from './routes/index.js';
import { pinia } from './stores/index.js';
import 'element-plus/theme-chalk/el-loading.css';
import 'animate.css';
import 'default-passive-events';
import 'nprogress/nprogress.css';
import 'virtual:uno.css';
import 'undraw-ui/dist/style.css';
import '@/assets/css/index.scss';

// 生产环境禁用开发者工具
if (window.location.origin.includes('3tclub.cn')) {
  DisableDevtool({
    disableMenu: false,
    md5: '4f0e473930d604e441c6d5306139d437',
  });
}

const app = createApp(App);

app.use(router);
app.use(VueQueryPlugin);
app.use(pinia);
app.use(VueDOMPurifyHTML);
app.use(directive);
app.mount('#app');
